var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"07.12.2025"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h3',[_vm._v("Geteert und gefedert (oder gestyroport)️")]),_c('p',[_c('img',{attrs:{"src":require("@/assets/day7.jpeg")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }